<template>
  <div
    :class="[
      'row official-profile-card official-profile-card--small',
      `official-profile-card--${official.party}`,
  ]">
    <div class="official-profile-card__summary">
      <div
        v-if="official.photo"
        :class="{'official-profile-card__image--labeled': !!official.label}"
        class="official-profile-card__image--wrapper mr-3">
        <img
          :src="official.photo"
          class="official-profile-card__image">
      </div>
      <div class="official-profile-card__info">
        <div class="official-profile-card__title mb-1">{{ official.title }}</div>

        <router-link
          :to="{ path: officialDetailRoute }"
          class="official-profile-card__name mb-2"
        >
          {{ official.name }}
        </router-link>

        <div class="official-profile-card__socials">
          <social-icon
            v-for="{ siteName, link } in socials"
            :class="'official-profile-card__social--' + siteName"
            :key="siteName"
            :site="siteName"
            :link="link"/>
        </div>
      </div>
    </div>
    <div 
      v-if="official.label" 
      class="official-profile-card__label-wrapper">
      <div class="official-profile-card__label">{{ official.label }}</div>
    </div>
  </div>
</template>

<script>
import SocialIcon from "./OfficialProfileCard/SocialIcon.vue";

export default {
  name: "OfficialProfileCardCompact",
  components: {
    SocialIcon
  },
  props: {
    official: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentRoute() {
      return this.$route.path;
    },
    socials() {
      const { socials = {} } = this.official;

      return Object.entries(socials)
        .map(([siteName, data]) => {
          const link = typeof data === "string" ? data : data.url;
          if (!link) return false;

          return {
            siteName,
            link
          };
        })
        .filter(item => item !== false);
    },
    officialDetailRoute() {
      return `${this.currentRoute}/${this.official.id}`;
    }
  }
};
</script>
